import { Component, Inject } from '@angular/core'
import { Routes } from '@angular/router'
import { CommonModule } from '@angular/common'
import { TranslateService } from '@ngx-translate/core'

import { BootstrapData } from 'elements-sdk'
import { BOOTSTRAP_DATA } from 'api'
import { LicenseService } from 'common/util/services/license.service'
import { PageTitleComponent } from 'common/util'
import { LocaleModule } from 'common/locale'
import { permissionGuard } from 'main/services/identity.service'
import { PartnersService } from 'licensing/components/partners.service'

@Component({
  selector: 'about-view',
  templateUrl: './aboutView.component.html',
  styleUrls: ['./aboutView.component.scss'],
  imports: [
    CommonModule,
    LocaleModule,
    PageTitleComponent,
  ],
})
export class AboutViewComponent {
  partnerInfo: Record<string, any>

  constructor (
    license: LicenseService,
    private readonly translate: TranslateService,
    partners: PartnersService,
    @Inject(BOOTSTRAP_DATA) bootstrapData: BootstrapData,
  ) {
    this.partnerInfo = bootstrapData.settings.partnerInfoOverride ?? partners.get(license.getLicense().partner!)!
  }

  readonly trademarkString$ = this.translate.get(`<b>ELEMENTS</b> is a trademark of <b>syslink GmbH</b>.`)

  static readonly routes: Routes = [
    {
      path: '',
      component: AboutViewComponent,
      canActivate: [permissionGuard('system:admin-access')],
    },
  ]
}
